import { render, staticRenderFns } from "./AcuTable.vue?vue&type=template&id=39b72e04"
import script from "./AcuTable.vue?vue&type=script&lang=js"
export * from "./AcuTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports